import { ComboBoxDropDownItem } from "@/Common/Components/Inputs/Combobox";
import { Locale } from "@/Common/Models/Localization/Locale";

class LicenceOrganisationSpecialisation {
    public Id: string;
    public SpecialisationCode: string;
    public NameEn: string;
    public NameFr: string;
    public NameEs: string;
    public IsActive: boolean;

    constructor(fields?: Partial<LicenceOrganisationSpecialisation>) {
        Object.assign(this, fields);
    }

    public static getSpecialtyName(model: LicenceOrganisationSpecialisation): string {
        switch (sessionStore.locale) {
            case Locale.fr: return model?.NameFr ?? "";
            case Locale.es: return model?.NameEs ?? "";
            default: return model?.NameEn ?? "";
        }
    }

    public toComboboxItem(): ComboBoxDropDownItem {
        return new ComboBoxDropDownItem(this.Id, LicenceOrganisationSpecialisation.getSpecialtyName(this));
    }
}

export { LicenceOrganisationSpecialisation };
